import React from 'react'
import IconStyle from './Style'
interface ISocialMedia {
  platformName: string
  width: number
}
export default function SocialMediaIcon({
  platformName,
  width,
}: ISocialMedia): JSX.Element {
  const renderIcon = (platformName: string): JSX.Element | '' => {
    const iconStyle = width ? { width, height: width } : {}
    switch (platformName?.trim()) {
      case 'Facebook':
        return <IconStyle.FacebookIconStyle sx={iconStyle} />
      case 'Youtube':
        return <IconStyle.YoutubeIconStyle sx={iconStyle} />
      case 'Reddit':
        return <IconStyle.RedditIconStyle sx={iconStyle} />
      case 'Instagram':
        return <IconStyle.InstagramIconStyle sx={iconStyle} />
      case 'Twitter':
        return <IconStyle.TwitterIconStyle sx={iconStyle} />
      case 'TikTok':
        return <IconStyle.TikTokIconStyle sx={iconStyle} />
      default:
        return ''
    }
  }

  return <>{renderIcon(platformName)}</>
}
